/**
 * Sorrel House · <sh-build> (sections/sh-build-table.liquid).
 * Etat : piece (obligatoire, choix unique), tiges (bascule), seconde piece (bascule ; la piece de
 * l'etape 1 est retiree de l'etape 3). Par defaut : premiere piece et premieres tiges.
 * Prix = somme des vrais prix, SAUF combinaison exacte d'une regle : le produit lot remplace les lignes
 * (prix facture = prix affiche). Lignes du panier dans data-lines du bouton, ajout par sh-cart.js.
 */
class ShBuild extends HTMLElement {
  connectedCallback() {
    try { this.rules = JSON.parse(this.querySelector('[data-build-rules]')?.textContent || '[]'); } catch (e) { this.rules = []; }
    this.threshold = Number(this.dataset.threshold) || 0;
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    this.fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur });
    this.state = { piece: null, stem: null, second: null };
    const first = (kind) => this.querySelector(`[data-pick][data-kind="${kind}"]`);
    if (first('piece')) this.state.piece = first('piece').dataset.product;
    if (first('stem')) this.state.stem = first('stem').dataset.product;
    this.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-pick]') : null;
      if (btn) { this.pick(btn.dataset.kind, btn.dataset.product); return; }
      if (e.target instanceof Element && e.target.closest('[data-build-bar-add]')) this.querySelector('[data-build-atc]')?.click();
    });
    this.render();
  }
  money(c) { return this.fmt.format((Number(c) || 0) / 100); }
  pick(kind, id) {
    if (kind === 'piece') {
      this.state.piece = id;
      if (this.state.second === id) this.state.second = null;
    } else {
      this.state[kind] = this.state[kind] === id ? null : id;
    }
    this.render();
  }
  item(kind) {
    const id = this.state[kind];
    if (!id) return null;
    const el = this.querySelector(`[data-pick][data-kind="${kind}"][data-product="${id}"]`);
    return el ? { id: Number(el.dataset.product), variant: Number(el.dataset.variant), price: Number(el.dataset.price), name: el.dataset.name } : null;
  }
  render() {
    this.querySelectorAll('[data-pick]').forEach((b) => {
      const on = this.state[b.dataset.kind] === b.dataset.product;
      b.setAttribute('aria-pressed', String(on));
      if (b.dataset.kind === 'second') b.hidden = b.dataset.product === this.state.piece;
    });
    const P = this.item('piece'); const S = this.item('stem'); const T = this.item('second');
    const rows = { piece: P, stem: S, second: T };
    Object.entries(rows).forEach(([k, it]) => {
      const row = this.querySelector(`[data-row="${k}"]`);
      if (!row) return;
      const name = row.querySelector('[data-name]');
      const price = row.querySelector('[data-price]');
      if (!name.dataset.empty) name.dataset.empty = name.textContent;
      name.textContent = it ? it.name : name.dataset.empty;
      name.classList.toggle('is-empty', !it);
      price.textContent = it ? this.money(it.price) : '';
    });
    const rule = P && this.rules.find((r) => r.available && r.piece === P.id && (r.stem || null) === (S ? S.id : null) && (r.second || null) === (T ? T.id : null));
    let total = 0; let lines = [];
    if (rule) {
      total = rule.price;
      lines = [{ id: rule.setVariant, quantity: 1 }];
    } else {
      [P, S, T].forEach((it) => { if (it) { total += it.price; lines.push({ id: it.variant, quantity: 1 }); } });
    }
    const setRow = this.querySelector('[data-setrow]');
    if (setRow) {
      setRow.hidden = !rule;
      if (rule) {
        setRow.querySelector('[data-setname]').textContent = `${rule.name} price`;
        setRow.querySelector('[data-saves]').textContent = rule.was > rule.price ? `Saves ${this.money(rule.was - rule.price)}` : '';
      }
    }
    this.querySelectorAll('[data-total]').forEach((t) => { t.textContent = this.money(total); });
    const atc = this.querySelector('[data-build-atc]');
    if (atc) {
      atc.dataset.lines = JSON.stringify(lines);
      atc.disabled = lines.length === 0;
      atc.textContent = `${atc.dataset.label} · ${this.money(total)}`;
    }
    const fill = this.querySelector('[data-fill]');
    const text = this.querySelector('[data-shiptext]');
    if (this.threshold > 0) {
      const pct = Math.min(100, Math.round((total / this.threshold) * 100));
      if (fill) fill.style.width = `${pct}%`;
      if (text) {
        const left = this.threshold - total;
        text.textContent = left > 0 ? (text.dataset.approach || '').replace('[amount]', this.money(left)) : (text.dataset.reached || '');
      }
    }
  }
}
if (!customElements.get('sh-build')) customElements.define('sh-build', ShBuild);
